import {Inject, Injectable} from '@angular/core';
import {IDatoControllo} from './models/dati-controllo.model';
import { IFileControlli } from './models/file-controlli.model';
import { CrudService } from 'src/app/core/services/crud.service';
import { IPrelievo } from './models/prelievo.model';
import { PRELIEVO_ENDPOINT,
        PRELIEVO_QUERY_SERVICE_INSTANCE, 
        PRELIEVO_EX_QUERY_SERVICE_INSTANCE,
        PARAMETRI_OBBLIGATORI_QUERY_SERVICE_INSTANCE,
        PARAMETRI_ALERT_QUERY_SERVICE_INSTANCE, 
        PRELIEVO_EX_ENDPOINT} from './trasmissione-reportnet.config';
import { QueryService } from 'src/app/core/services/query.service';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { IParametriAlert } from '../controlli/models/parametri-alert';


const CRUD_ENDPOINT = 'superamenti-reportnet3';
const CRUD_ENDPOINT_DETTAGLIO= 'controlli';
const SEND_JSON_ENDPOINT = 'elaborazione-reportnet3';
const SEND_FILE_ENDPOINT = 'elaborazione-reportnet3';
const ERROR_CONTROLLI_PARAM = 'controllo';
@Injectable({
  providedIn: 'root'
})
export class TrasmissioneReportNetService extends CrudService<IParametriAlert> {

  constructor(
    @Inject(PRELIEVO_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<IPrelievo>,
    @Inject(PRELIEVO_EX_QUERY_SERVICE_INSTANCE) public readonly queryListaDettaglio: QueryService<IPrelievo>,
    @Inject(PARAMETRI_OBBLIGATORI_QUERY_SERVICE_INSTANCE) public readonly queryObbErr: QueryService<IPrelievo>,
    @Inject(PARAMETRI_ALERT_QUERY_SERVICE_INSTANCE) public readonly queryAlertErr: QueryService<IPrelievo>,
    @Inject(ApiService) protected override readonly api: ApiService,
    @Inject(SnackbarService) protected override readonly snackbar: SnackbarService
  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(CRUD_ENDPOINT, api, snackbar);
  }

  get(id: number) {
    return this.api.get(`${CRUD_ENDPOINT}/${id}`);
  }
  
  sendJson(controllo: IDatoControllo) {
    return this.api.post<any>(SEND_JSON_ENDPOINT, controllo);
  }

  sendFile(file: IFileControlli) {
    return this.api.post<any>(SEND_FILE_ENDPOINT, file);
  }


  sendReportnet(url: string, data: {}) {
    return this.api.post( CRUD_ENDPOINT, data)
  }
  checkElaborazioneFile(param:any){
    return this.api.get(`elaborazione/${param}`);
  }

}
